import { useReduxSelector } from '.';

export default function useEnvironment() {
  return useReduxSelector((state) => state.environment);
}
